"use client";

import React from "react";
import { Instagram, Linkedin, Twitter, Facebook } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="26575" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-4 w-24 bg-muted/20 animate-pulse rounded-sm" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary hover:translate-x-1 transition-all duration-300 text-sm font-semibold">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function BrandFooter() {
  const currentYear = new Date().getFullYear();
  return <section id="footer-essentials" className="relative overflow-hidden bg-secondary text-foreground py-16 px-4 md:px-8 lg:px-12 border-t border-border/50">
      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-primary/5 rounded-full blur-3xl opacity-50" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-accent/10 rounded-full blur-3xl opacity-50" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {}
          <div className="flex flex-col items-start space-y-6">
            <img src="https://cliffhanger.websiteshop.au/wp-content/uploads/2026/03/CHP-Logo-Master.png" alt="Cliff Hanger Plumbing" className="h-10 w-auto object-contain" />
            <p className="text-muted-foreground text-base leading-relaxed max-w-xs">
              Reliable plumbing solutions for Narara and the Central Coast. We combine modern technology with traditional service to keep your home running smoothly.
            </p>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-sans text-xl font-bold tracking-tight text-primary">Read More</h3>
            <MenuProvider menu_id="18" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-sans text-xl font-bold tracking-tight text-primary">Contact</h3>
            <div className="flex flex-col gap-3 text-muted-foreground text-sm font-semibold">
              <p>Central Coast region</p>
              <Link to="tel:0419 818 188" className="hover:text-primary transition-colors duration-300">
                0419 818 188
              </Link>
              <p>Emergency 24/7 Available</p>
            </div>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-sans text-xl font-bold tracking-tight text-primary">Social Links</h3>
            <div className="flex items-center gap-5">
              <Link to="https://www.instagram.com/cliffhangerplumbing/" newTab className="text-muted-foreground hover:text-primary transition-colors duration-300">
                <Instagram className="size-6" />
              </Link>
              <Link to="https://www.facebook.com/p/Cliff-Hanger-Plumbing-61556848176444/" newTab className="text-muted-foreground hover:text-primary transition-colors duration-300">
                <Facebook className="size-6" />
              </Link>
            </div>
          </div>
          
        </div>

        <Separator className="bg-border/40 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground/80 font-bold uppercase tracking-widest">
          <p>© 2026 Cliff Hanger Plumbing. ABN. 53 673 252 143 Central coast website build by <Link to="https://www.websiteshop.com.au" newTab className="text-[#023f82] hover:opacity-80 transition-opacity">website shop</Link></p>
          
        </div>
      </div>
    </section>;
}